import { AvailabilityMode, DurationMode } from "PFTypes/booking";

export const DEFAULT_MONTHS_FORWARD_LIMIT = 6;

export const ROOT_ERROR_KEY = "availability";
export const RANGES_ERROR_KEY = `${ROOT_ERROR_KEY}[ranges]`;
export const DURATION_VALUE_ERROR_KEY = `[duration][value]`;
export const DURATION_MODE_ERROR_KEY = `[duration][mode]`;
export const START_ERROR_KEY = `[start]`;
export const END_ERROR_KEY = `[end]`;
export const PHASES_ERROR_KEY = `[phase_source_id]`;
export const BOOKING_CATEGORY_ERROR_KEY = "booking_category_id";
export const AVAILABILITY_MODES = [
  AvailabilityMode.TimeRule,
  AvailabilityMode.Within,
  AvailabilityMode.PerWeek,
  AvailabilityMode.PerMonth
];
export const DURATION_MODES = [DurationMode.Days, DurationMode.Hours];
